import { Setting, SETTING } from '@favid-inc/api';
import { Get, Put } from '@favid-inc/api/lib/rest';
import { request as client } from 'utils';

export async function fetchSettings() {
  type Action = Get<Setting>;

  const request: Action['Request'] = {
    method: 'GET',
    url: `/${SETTING}`,
  };

  return await client.request<Action['Response']>(request);
}

export async function saveSetting(setting: Setting) {
  type Action = Put<Setting>;

  const request: Action['Request'] = {
    method: 'PUT',
    url: `/${SETTING}/${setting.id}`,
    data: setting,
  };

  return await client.request<Action['Response']>(request);
}
